import { useEffect, useState } from "react";
import { Progress, Spinner } from "@nextui-org/react";
import { apiRequest } from "lib/api/apiClient";
import { useDispatch } from "react-redux";
import { setCurrentUser } from "store/user/user.action";
import { useNavigate } from "react-router-dom";
import { userActions } from "store/user/user.slice";

function Propagate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const verifyUser = async () => {
    try {
      const response = await apiRequest("/api/v1/auth/user", { method: "GET" });
      console.log(response);

      if (response) {
        dispatch(userActions.setCurrentUser(response));
        dispatch(userActions.setIsLoggedIn(true));
        navigate("/dashboard");
      } else {
        throw new Error("No user data found");
      }
    } catch (err: any) {
      console.error("Failed to fetch user:", err);
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verifyUser();
  }, []);

  if (loading) {
    return (
      <div
        className="w-full h-screen centered overflow-y-auto overflow-x-hidden bg-cover bg-white dark:bg-dark-bg bg-center bg-no-repeat bg-fixed"
        style={{ backgroundImage: 'url("/placeholder.svg")' }}
      >
        {/* Either use spinner OR indeterminate progress */}
        <Progress
          aria-label="Loading..."
          className="max-w-md"
          isIndeterminate
        />
        {/* Alternative: <Spinner label="Loading user..." /> */}
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="w-full h-screen centered overflow-y-auto overflow-x-hidden bg-cover bg-white dark:bg-dark-bg bg-center bg-no-repeat bg-fixed"
        style={{ backgroundImage: 'url("/placeholder.svg")' }}
      >
        <p className="text-red-500 font-medium">{error}</p>
      </div>
    );
  }

  // If loaded and no error, don’t render loading screen
  return null;
}

export default Propagate;
